import React from 'react';
import { CoreForumCreateReply } from '../core/CoreForumCreateReply';

/**
 * ChatRoomCreateReply - ChatRoom 专用的回复组件包装器
 * @param {Function} props.buildGroupContext - 从页面传递的 context 构建函数
 * @param {string} props.mode - 模式标识
 * @param {string} props.activityId - 活動 ID（可選）
 * @param {string} props.groupId - 群組 ID（可選）
 * @param {string} props.nodeId - 節點 ID（可選）
 */
export const ChatRoomCreateReply = ({ 
  open, 
  onClose, 
  nodeContent, 
  ws, 
  groupId, 
  graphNodes,
  graphEdges,
  allTagConfigs = {},
  buildGroupContext,
  mode = 'chat',
  activityId, // ✅ 新增參數
  nodeId // ✅ 新增參數
}) => {
  return (
    <CoreForumCreateReply
      open={open}
      onClose={onClose}
      nodeContent={nodeContent}
      ws={ws}
      groupId={groupId}
      graphNodes={graphNodes}
      graphEdges={graphEdges}
      allTagConfigs={allTagConfigs}
      buildGroupContext={buildGroupContext}
      mode={mode}
      activityId={activityId} // ✅ 傳遞參數
      nodeId={nodeId} // ✅ 傳遞參數
    />
  );
};